import { io } from "socket.io-client";

// Get slug from ?slug=demo (default "demo")
export function getSlug() {
  const u = new URL(window.location.href);
  return u.searchParams.get('slug') || 'demo';
}

// Simple API wrapper (same-origin)
export async function api(path, { method='GET', body, pin } = {}) {
  const res = await fetch(path, {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...(pin ? { 'x-admin-pin': pin } : {})
    },
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export function connectSocket({ slug }) {
  return io(window.location.origin, {
    transports: ['websocket','polling'],
    query: { slug }
  });
}
